<template>
    <div class="page-account page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">店铺管理员管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>客户管理</el-breadcrumb-item>
                            <el-breadcrumb-item>店铺管理员管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleAccount('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="name" label="店铺名称：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="店铺名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="status" label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
                            <el-table-column prop="username" align="center" label="用户名" min-width="120">
                            </el-table-column>
                            <el-table-column prop="name" align="center" label="管理员姓名" min-width="120">
                            </el-table-column>
                            <el-table-column prop="desk_names" align="center" label="所属店铺" min-width="220">
                                <template slot-scope="scope">
                                    <span v-for="(item, index) in scope.row.desk_names" :key="index">{{item}}{{index>0?'，':''}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="desk_numbers" align="center" label="店铺编码" min-width="150">
                                <template slot-scope="scope">
                                    <span v-for="(item, index) in scope.row.desk_numbers" :key="index">{{item}}{{index>0?'，':''}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="last_open_id" align="center" label="最后登录openId" min-width="260">
                            </el-table-column>
                           <!-- <el-table-column prop="m_time" align="center" label="最后登录时间" min-width="160">
                            </el-table-column>-->
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="150" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleAccount('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteAccount(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export account-dialog" :title="dlg_account.title" :visible.sync="dlg_account.visible" width="534px" @closed="closeAccount" :close-on-click-modal="false">
            <el-form ref="formAccount" :model="dlg_account.form" label-width="110px" :rules="dlg_account.rules" @submit.native.prevent>
                <el-form-item prop="username" style="margin-top: 15px;" label="用户名：" :error="dlg_account.error.username" clearable>
                    <el-input size="small" v-model="dlg_account.form.username" placeholder='请输入用户名' clearable></el-input>
                </el-form-item>
                <el-form-item prop="password" label="密码：">
                    <el-input size="small" type='password' v-model="dlg_account.form.password" placeholder='请输入密码' :error="dlg_account.error.password" clearable></el-input>
                </el-form-item>
                <el-form-item prop="re_password" label="确认密码：">
                    <el-input size="small" type='password' v-model="dlg_account.re_password" placeholder='请再次输入密码' clearable></el-input>
                </el-form-item>
                <el-form-item prop="name" label="管理员姓名：">
                    <el-input size="small" v-model="dlg_account.form.name" placeholder='请输入管理员姓名' clearable></el-input>
                </el-form-item>
                <!--<el-form-item prop="desk_numbers" label="店铺编号：">
                    <el-input size="small" v-model="dlg_account.form.desk_numbers" placeholder='请输入店铺编号' clearable></el-input>
                </el-form-item>-->
                <el-form-item  prop="desk_numbers" label="设置店铺：" :error="dlg_account.error.desk_numbers">
                    <el-select size="small" v-model="dlg_account.desk_numbers" multiple placeholder="请选择" style="width: 100%;" @change="changeSelect">
                        <el-option
                                v-for="item in dlg_account.init_data.desk_list"
                                :key="item.number"
                                :label="item.name"
                                :value="item.number">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="status" label="状态：">
                    <el-radio-group v-model="dlg_account.form.status">
                        <el-radio v-for="(item, index) in dlg_account.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_account.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitAccount()" :loading="dlg_account.btn_loading">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    import CryptoJS from 'crypto-js'
    export default {
        name: 'usercenter',
        data() {
            return {
                drawer: false,
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                baseUrl:this.$client.IMG_URL,
                timestamp:new Date().getTime(),
                //搜索
                form_search:{
                    //id: "",
                    name:"",
                    status: -1
                },
                init_data: {
                    status_list: [],
                },
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_account:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    type:'',
                    re_password:'',
                    desk_numbers:[],
                    form:{
                        username:'',
                        password:'',
                        name:'',
                        desk_numbers:'',
                        status:1
                    },
                    error:{
                        username:'',
                        password:'',
                        desk_numbers:''
                    },
                    reset_form: {},
                    init_data:{
                        status_list: [],
                        desk_list:[]
                    },
                    rules:{
                        username:{required: true, message: '请输入用户名', trigger: ['change','blur']},
                        desk_numbers:{required: true, message: '请选择店铺', trigger: ['change','blur']},
                        status:{required: true, message: '请选择状态', trigger: ['change','blur']},
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '店铺管理员管理';
            this.dlg_account.reset_form = Object.assign({}, this.dlg_account.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/deskadmin/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_account.init_data.status_list = res.status_name_list;
                    _this.dlg_account.init_data.desk_list = res.desk_list;
                    _this.init_data.status_list = status_list.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的店铺");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/deskadmin/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },

            handleAccount(type,data){
                this.dlg_account.visible = true;
                this.dlg_account.type = type;
                if(type == 'add'){
                    this.dlg_account.title = '添加店铺管理员';
                    this.dlg_account.api = '/adminapi/deskadmin/save';
                }else{
                    this.dlg_account.id= data.id;
                    this.dlg_account.title = '编辑店铺管理员';
                    if(data){
                        for(var key in this.dlg_account.form){
                            this.dlg_account.form[key] = data[key];
                        }
                    }
                    this.dlg_account.form.password='';
                    this.dlg_account.desk_numbers = data.desk_numbers;
                    if(data.desk_numbers){
                        this.dlg_account.form.desk_numbers = data.desk_numbers.toString();
                    }
                    this.dlg_account.api = '/adminapi/deskadmin/save?id=' + data.id;
                }
            },
            changeSelect(val){
                //console.log(val.toString());
                if(val){
                    this.dlg_account.form.desk_numbers = val.toString();
                }
            },
            deleteAccount(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/deskadmin/delete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            submitAccount(){
                var _this = this;
                _this.$refs['formAccount'].validate((valid) => {
                    if(_this.dlg_account.type == 'add'&&_this.dlg_account.form.password==''){
                    _this.$message("请设置密码");
                    return;
                    }
                    if(_this.dlg_account.form.password != _this.dlg_account.re_password){
                        _this.$message("两次密码输入不一致");
                        return;
                    }
                    if(_this.dlg_account.form.password!=''){
                        _this.dlg_account.form.password = CryptoJS.MD5(_this.dlg_account.form.password).toString();
                        _this.dlg_account.re_password = CryptoJS.MD5(_this.dlg_account.form.password).toString();
                    }
                    if (valid) {
                        this.dlg_account.btn_loading = true;
                        this.$client.post(this.dlg_account.api, this.dlg_account.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_account.btn_loading = false;
                            _this.dlg_account.visible = false;
                        }, function(message){
                            _this.dlg_account.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_account.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeAccount(){
                this.dlg_account.re_password = '';
                for(var key in this.dlg_account.form){
                    this.dlg_account.form[key] = this.dlg_account.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formAccount.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .page-account .el-upload--picture-card{
        line-height: 80px;
    }
    .page-account .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
</style>
<style scoped>


</style>